import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-3-dot-menu-vertical",
  "use": "icon-3-dot-menu-vertical-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-3-dot-menu-vertical\">\n    <path class=\"cls-1\" d=\"M17.06,22.93a3.06,3.06,0,1,0-3.06,3A3,3,0,0,0,17.06,22.93Z\" />\n    <path class=\"cls-1\" d=\"M10.94,4.93a3.06,3.06,0,0,0,6.12,0,3.06,3.06,0,0,0-6.12,0Z\" />\n    <path class=\"cls-1\" d=\"M14,16.93a3,3,0,1,0-3.06-3A3,3,0,0,0,14,16.93Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol